<template>
  <LoadingIndicator
    v-if="loadingData"
    class="mt-5"
  />

  <PageWrap :page-title="pageTitle" v-else>
    <b-row>
      <b-col md="10" lg="8">
        <ApplicantForm
          :data="formData"
          :editing="isEditing"
          :errors="formErrors"
          @update="updateForm"
        />
      </b-col>
    </b-row>
    <div>
      <BfButton
        v-if="!isEditing"
        @click="createApplicant"
      >
        Guardar
      </BfButton>
      <BfButton
        v-if="isEditing"
        variant="red"
        @click="showDeleteModal"
      >
        Eliminar
      </BfButton>

      <DeleteWarningModal
        v-model="displayDeleteModal"
        title="¿Desea eliminar este cliente?"
        @confirm-deletion="deleteApplicant"
      />
    </div>
  </PageWrap>
</template>

<script>
import ApplicantForm from '@/components/FormGroups/ApplicantForm';
import PageWrap from '@/components/PageWrap';
import LoadingIndicator from '@/components/LoadingIndicator';
import { applicantAPI } from '@/api';
import DeleteWarningModal from '@/components/DeleteWarningModal';


export default {
  name: 'ApplicantsDetail',

  props: {
    id: {
      type: String,
    },
  },

  data() {
    return {
      formData: {},
      formErrors: {},
      loadingData: false,
      displayDeleteModal: false,
    };
  },

  async created() {
    this.loadingData = true;

    try {
      if (this.isEditing) {
        await this.loadData();
      } else {
        this.loadPreData();
      }
    } finally {
      this.loadingData = false;
    }
  },

  methods: {
    async loadData() {
      const {
        data: [applicantData],
      } = await applicantAPI.get(this.id);
      this.formData = applicantData;
    },

    async loadPreData() {
      const { data } = await applicantAPI.preCreate();

      this.formData = data;
    },

    async updateForm({ key, value }) {
      const newData = { [key]: value };

      if (!this.isEditing) {
        this.formData = {
          ...this.formData,
          ...newData,
        };
      } else {
        this.formErrors = {};

        try {
          const { data, message } = await applicantAPI.update({
            id: this.id,
            data: newData,
          });

          this.formData = data;
          this.$bfNotify({ title: 'Actualizado', message, type: 'success' });
        } catch ({ errors, message }) {
          this.formErrors = errors;
          this.$bfNotify({
            title: 'Error',
            message,
            type: 'error',
          });
        }
      }
    },

    async createApplicant() {
      try {
        this.formErrors = {};
        const { data, message } = await applicantAPI.create(this.formData);

        this.$bfNotify({ title: 'Guardado', message, type: 'success' });
        this.$router.replace({
          name: 'applicant',
          params: { id: `${data.id}` },
        });
      } catch ({ errors, message }) {
        this.formErrors = errors;
        this.$bfNotify({
          title: 'Error',
          message: 'Existe un error con tus datos',
          type: 'error',
        });
      }
    },

    async deleteApplicant() {
      try {
        const { message } = await applicantAPI.delete(this.id);

        this.$bfNotify({ title: 'Eliminado', message, type: 'success' });
        this.$router.replace({ name: 'applicants' });
      } catch ({ message }) {
        this.$bfNotify({ title: 'Error', message, type: 'error' });
      }
    },
    async showDeleteModal() {
      this.displayDeleteModal = true;
    },
  },

  computed: {
    isEditing() {
      return !!this.id;
    },

    pageTitle() {
      return this.isEditing ? `Cliente: ${this.formData.nombre}` : 'Crear Cliente';
    },
  },

  components: {
    ApplicantForm,
    LoadingIndicator,
    PageWrap,
    DeleteWarningModal,
  },
};
</script>
